import { useState, useEffect, useCallback } from 'react';
import FontLoader, { FONT_CONFIGS } from '../utils/fontLoader';

interface UseFontLoaderOptions {
  delay?: number; // 延遲載入時間（毫秒）
  loadOnMount?: boolean; // 是否在組件掛載時載入
}

export const useFontLoader = (options: UseFontLoaderOptions = {}) => {
  const { delay = 0, loadOnMount = true } = options;
  const [isLoading, setIsLoading] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadFonts = useCallback(async () => {
    // 如果已經載入完成，直接返回
    if (isLoaded) {
      console.log('字體已經載入完成，跳過重複載入');
      return;
    }
    
    // 如果正在載入中，直接返回
    if (isLoading) {
      console.log('字體正在載入中，跳過重複載入');
      return;
    }
    
    // console.log('開始載入字體...');
    setIsLoading(true);
    setError(null);

    try {
      const fontLoader = FontLoader.getInstance();
      await fontLoader.loadFonts(FONT_CONFIGS);
      setIsLoaded(true);
      // console.log('所有字體載入完成');
    } catch (err) {
      setError(err instanceof Error ? err.message : '字體載入失敗');
      // console.error('字體載入錯誤:', err);
    } finally {
      setIsLoading(false);
    }
  }, [isLoading, isLoaded]);

  useEffect(() => {
    if (!loadOnMount) return;

    if (delay > 0) {
      const timer = setTimeout(loadFonts, delay);
      return () => clearTimeout(timer);
    } else {
      loadFonts();
    }
  }, [delay, loadOnMount, loadFonts]);

  return {
    isLoading,
    isLoaded,
    error,
    loadFonts
  };
};
